export const titleVerbTense = (scoreTypeSelected) => {
    switch (scoreTypeSelected) {
      case "Nostalgia":
        return "made";
      case "React":
        return "first made";
      case "Replay":
        return "makes";
      default:
        return null;
    }
  };

  export const compScoreFinalCalculation = (ratings, connectionScoreSetter) => {
    const trackIds = Object.keys(ratings)
    const overallPossibleTotal = trackIds.length * 5;
    const userTotal = trackIds.reduce((total, id) => total + ratings[id].score, 0);
    const score = (userTotal / overallPossibleTotal) * 10;
    const finalScore = parseFloat(score.toFixed(1));
    connectionScoreSetter(finalScore);
  };
